export default (ctx, key) => {
  let strings = {
    "duplicate": `An organization with name ${ctx.name} already exists.`,
    "something_went_wrong": "Something went wrong. Please try again later.",
    "invitation_pending": "Invitation pending",
    "confirm_removing_user_from_organization": `Please confirm removing ${ctx.user} from organization ${ctx.organization}.`,
    "confirm_removing_organization_from_organization": `Please confirm removing organization ${ctx.user} from organization ${ctx.organization}.`,
    "confirm_removing_organization_invitationn": `Please confirm removing invitation of organization ${ctx.user}`,
    "cannot_remove_the_last_owner": "You cannot remove the last owner.",
    "confirm_make_owner": `Please confirm to upgrade ${ctx.user} to an owner of organization ${ctx.organization}`,
    "confirm_make_member": `Please confirm to downgrade ${ctx.user} to a member of organization ${ctx.organization}`,
    "successfully_add_api_key": "Api key secret has been generated.",
    "successfully_copy_api_key": "Api key secret has been copied!",
    "confirm_deleting_api_key": `Please confirm to delete the API key with label ${ctx.label} because it might lead to service unavailabilty if this key would still be used somewhere.`,
    "confirm_leave": `Are you sure that you want to leave organization ${ctx.organization}`,
    "leave_error": `You're the last owner of ${ctx.organization}, Last owner can't leave`,
    "leave_successfully": `You successfully leave ${ctx.organization}`,
    "confirm_delete_org": `Are you sure you want to delete ${ctx.organization} ?`,
    "confirm_delete_org_invitations": `Are you sure you want to cancel invitation to ${ctx.user} ?`,
    "delete_org_successfully": `You sucessfully delete ${ctx.organization}`,
    "confirm_removing_pending_invitation": `Please confirm removing invitation of ${ctx.user} from organization ${ctx.organization}.`
  }
  return strings[key]
}
